exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._7YgGzjF_0O_PBYxm3EwGw{height:100%;position:relative}._7YgGzjF_0O_PBYxm3EwGw .AxW8eK-ze98y6Ix3-fy7m{position:absolute;top:0;padding-top:80px;height:100%;background-color:hsla(0,0%,100%,.7);width:100%;text-align:center;color:#000;z-index:999}", ""]);

// Exports
exports.locals = {
	"loader": "_7YgGzjF_0O_PBYxm3EwGw",
	"loader_inner": "AxW8eK-ze98y6Ix3-fy7m"
};